// client/src/lib/returningVisitorService.ts

const LAST_ACTIVITY_KEY = 'delphina_last_activity';
const INACTIVITY_THRESHOLD_MS = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

/**
 * Get the last activity timestamp from localStorage
 * @returns Unix timestamp in ms, or null if not set
 */
export function getLastActivityTimestamp(): number | null {
  if (typeof window === 'undefined') return null;
  const stored = localStorage.getItem(LAST_ACTIVITY_KEY);
  return stored ? parseInt(stored, 10) : null;
}

/**
 * Set the current timestamp as last activity in localStorage
 */
export function setLastActivityTimestamp(): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
}

/**
 * Check if the user is considered a "returning visitor"
 * Returns true if last activity was 2+ hours ago
 */
export function isReturningVisitor(): boolean {
  const lastActivity = getLastActivityTimestamp();
  if (!lastActivity) return false;
  return Date.now() - lastActivity >= INACTIVITY_THRESHOLD_MS;
}

/**
 * Get hours since last activity (for notification message)
 * @returns Hours as a decimal (e.g., 2.5), or null if no last activity
 */
export function getHoursSinceLastActivity(): number | null {
  const lastActivity = getLastActivityTimestamp();
  if (!lastActivity) return null;
  return Math.round((Date.now() - lastActivity) / (1000 * 60 * 60) * 10) / 10;
}
